import type { DockSectionDefinition } from "./sectionTypes";
import { ActivityDockPlantMaterialRequestSection } from "./sections/ActivityDockPlantMaterialRequestSection";
import {
  MFG_DESK_ROLES,
  MFG_PLANT_MANAGER_ROLE,
  MFG_PLANT_SUPERVISOR_ROLE,
  MFG_PURCHASING_ROLE,
} from "@/lib/roles/turboManufacturingRoles";
import { OPS_REVIEWER_ROLES } from "@/lib/roles/turboOpsRoles";

export const PLANT_MATERIAL_REQUEST_DOCK_ENTRIES: readonly DockSectionDefinition[] = [
  {
    id: "plant-material-request",
    roleGate: {
      roles: [
        MFG_PURCHASING_ROLE,
        ...MFG_DESK_ROLES,
        MFG_PLANT_MANAGER_ROLE,
        MFG_PLANT_SUPERVISOR_ROLE,
        ...OPS_REVIEWER_ROLES,
      ],
    },
    render: (ctx) => (
      <ActivityDockPlantMaterialRequestSection
        reviewCount={ctx.plantRequestReviewCount ?? null}
        statusItems={ctx.plantRequestStatusItems ?? null}
        onOpenMfgPurchasing={ctx.onOpenMfgPurchasing}
      />
    ),
    bucketRelevance: ["production", "manufacturing", "ops"],
    modeRelevance: ["mfgPurchasing"],
    hasSignal: (ctx) =>
      (ctx.plantRequestReviewCount ?? 0) > 0 &&
      ctx.hasRole(MFG_PURCHASING_ROLE, ...MFG_DESK_ROLES),
  },
];
